import toast                   from "_common/toast";
import { useSetAdWatchStatus } from "_jotai/rooterPro";

import Presentation from "./presentation";

const component = ( { onAdFinish } ) => {

	const setAdWatchStatus = useSetAdWatchStatus ();
	const onAdSkip         = () => {
		toast.error ( "Ad skipped" );
		setAdWatchStatus ( { opened: false, skipped: true, finished: false } );
	};

	return (
		<Presentation
			onAdFinish = { onAdFinish }
			onAdSkip   = { onAdSkip }
		/>
	);
};

export default component;
